import { jsx } from "react/jsx-runtime";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { IconButton, InputAdornment } from "@mui/material";
import { useCallback, useState } from "react";
import { validateTidalLicense } from "@workwave-tidal/core/base";
import { useFormFairyBridge } from "../../hooks/useFormFairyBridge.js";
import { FormUITextField } from "../primitives/FormUITextField.js";
function Password(props) {
  const { autoFocus, placeholder, textfieldProps = {}, defaultPasswordVisibility = "hide", ...bridgeOptions } = props;
  const {
    config: { fullWidth, label, name, testId = "password-root" },
    fieldInfo: {
      errorOrHelperText,
      field: { required, visible },
      fieldDisabled,
      fieldHasError,
      onBlur,
      onChange,
      onFocus,
      showErrorAccent,
      value
    }
  } = useFormFairyBridge(bridgeOptions);
  const [showPassword, setShowPassword] = useState(defaultPasswordVisibility === "show");
  const handleOnChange = (event) => {
    onChange(event.currentTarget.value);
  };
  const onVisibilityIconClick = useCallback(() => {
    setShowPassword(!showPassword);
  }, [showPassword]);
  if (!visible) return null;
  return /* @__PURE__ */ jsx(
    FormUITextField,
    {
      label,
      fullWidth,
      autoFocus,
      placeholder,
      ...textfieldProps,
      type: showPassword ? "text" : "password",
      name,
      value,
      error: fieldHasError && showErrorAccent,
      onBlur,
      onFocus,
      onChange: handleOnChange,
      disabled: fieldDisabled,
      required,
      helperText: errorOrHelperText,
      testId,
      "data-tidal": "Password",
      InputProps: {
        endAdornment: /* @__PURE__ */ jsx(InputAdornment, { position: "start", children: /* @__PURE__ */ jsx(
          IconButton,
          {
            "aria-label": "toggle password visibility",
            onClick: onVisibilityIconClick,
            tabIndex: -1,
            edge: "end",
            children: showPassword ? /* @__PURE__ */ jsx(VisibilityOff, {}) : /* @__PURE__ */ jsx(Visibility, {})
          }
        ) })
      }
    }
  );
}
validateTidalLicense();
export {
  Password
};
//# sourceMappingURL=Password.js.map
